import { forwardRef, type LegacyRef } from 'react';
import { useParams } from 'react-router-dom';
import assert from 'assert';
import { useAppSelector } from '../../../store/hooks';
import StateDecorator from '../../../components/utils/state/StateDecorator';
import { isDataState } from '../../../store/data/state';
import { getOrElse } from '../../../utils/functions';
import ManagementDecorator from '../ManagementDecorator';
import { useTranslation } from 'react-i18next';

function getInstanceById<T extends { id: number }>(
  data: Record<number, T>,
  id: number
): T | undefined {
  return data[id];
}

function Station(_: object, ref: LegacyRef<HTMLDivElement>): JSX.Element {
  const { t } = useTranslation('components.users');
  const params = useParams();
  //TODO: Au lieux d'un assert afficher une erreur.
  assert(params['station_id']);
  const siteDeviceId = Number.parseInt(params['station_id']);

  const sites = useAppSelector((state) => state.data_slice.externals.sites);
  const site_devices = useAppSelector(
    (state) => state.data_slice.externals.measure_points
  );

  return ManagementDecorator(ref, () =>
    StateDecorator([sites, site_devices], ref, () => {
      assert(isDataState(sites));
      assert(isDataState(site_devices));

      const deviceSite = getInstanceById(site_devices.data, siteDeviceId);
      const site = Object.values(sites.data).find(
        (s) => s.id === deviceSite!.site_id
      );

      if (deviceSite === undefined)
        return <div>{t('Station non trouvée')}</div>;

      const headings = [
        t('Nom'),
        t("Date de début d'assignement"),
        t("Date de fin d'assigement"),
        t("Site d'assigment"),
      ];
      type FormattedKey = (typeof headings)[number];
      type Formatted = { [key in FormattedKey]: string };
      const formatted: Formatted = {
        Nom: getOrElse(deviceSite.name),
        "Date de début d'assignement": getOrElse(
          deviceSite.device_site?.start_assignement_date
        ),
        "Date de fin d'assigement": getOrElse(
          deviceSite.device_site?.end_assignement_date
        ),
        "Site d'assigment": getOrElse(site ? site.name : ''),
      };

      return (
        <table className="uk-table uk-table-divider">
          <tbody>
            {Object.entries(formatted).map(([key, val]) => (
              <tr>
                <th style={{ width: '25%', textAlign: 'right' }}>{key}</th>
                <td>{val}</td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    })
  );
}

export default forwardRef(Station);
